// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UAAlarmCondition
 */
export interface UAAlarmCondition {
    /**
     * 
     */
    browseName: string;
    /**
     * 
     */
    displayName: string;
    /**
     * 
     */
    eventId: string;
    /**
     * 
     */
    eventType: string;
    /**
     * String to reference another node
     */
    sourceNode: string;
    /**
     * 
     */
    sourceName?: string;
    /**
     * 
     */
    readonly time?: Date;
    /**
     * 
     */
    receiveTime: Date;
    /**
     * 
     */
    message: string;
    /**
     * value between 1 (low) to 1000 (highest)
     */
    severity: number;
    /**
     * 
     */
    conditionName: string;
    /**
     * 
     */
    retain?: boolean;
    /**
     * 
     */
    enabledState: boolean;
    /**
     * bitmask for status code
     */
    quality?: string;
    /**
     * value between 1 (low) to 1000 (highest)
     */
    lastSeverity: number;
    /**
     * comment by user
     */
    comment?: string;
    /**
     * user who made the comment
     */
    clientUserId?: string;
    /**
     * 
     */
    ackedState: boolean;
    /**
     * indicated if the alarm state has been confirmed or not
     */
    confirmedState?: boolean;
    /**
     * indicates if the alarm condition is currently active
     */
    activeState: boolean;
    /**
     * indicated if the alarm condition is suppressed
     */
    suppressedState?: boolean;
    /**
     * indicates if the alarm condition causes the device to be non functional / out of service
     */
    outOfServiceState?: boolean;
    /**
     * indicated if the active alarm is shelved by a user
     */
    shelvingState?: boolean;
    /**
     * indicates if the active alarm condition shall be ignored by configuration.
     * Either by shelfing a single occurance or if it es gernerally suppressed
     */
    suppressedOrShelved: boolean;
}

/**
 * Check if a given object implements the UAAlarmCondition interface.
 */
export function instanceOfUAAlarmCondition(value: object): value is UAAlarmCondition {
    if (!('browseName' in value) || value['browseName'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('sourceNode' in value) || value['sourceNode'] === undefined) return false;
    if (!('receiveTime' in value) || value['receiveTime'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('severity' in value) || value['severity'] === undefined) return false;
    if (!('conditionName' in value) || value['conditionName'] === undefined) return false;
    if (!('enabledState' in value) || value['enabledState'] === undefined) return false;
    if (!('lastSeverity' in value) || value['lastSeverity'] === undefined) return false;
    if (!('ackedState' in value) || value['ackedState'] === undefined) return false;
    if (!('activeState' in value) || value['activeState'] === undefined) return false;
    if (!('suppressedOrShelved' in value) || value['suppressedOrShelved'] === undefined) return false;
    return true;
}

export function UAAlarmConditionFromJSON(json: any): UAAlarmCondition {
    return UAAlarmConditionFromJSONTyped(json, false);
}

export function UAAlarmConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UAAlarmCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'browseName': json['browseName'],
        'displayName': json['displayName'],
        'eventId': json['eventId'],
        'eventType': json['eventType'],
        'sourceNode': json['sourceNode'],
        'sourceName': json['sourceName'] == null ? undefined : json['sourceName'],
        'time': json['time'] == null ? undefined : (new Date(json['time'])),
        'receiveTime': (new Date(json['receiveTime'])),
        'message': json['message'],
        'severity': json['severity'],
        'conditionName': json['conditionName'],
        'retain': json['retain'] == null ? undefined : json['retain'],
        'enabledState': json['enabledState'],
        'quality': json['quality'] == null ? undefined : json['quality'],
        'lastSeverity': json['lastSeverity'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'clientUserId': json['clientUserId'] == null ? undefined : json['clientUserId'],
        'ackedState': json['ackedState'],
        'confirmedState': json['confirmedState'] == null ? undefined : json['confirmedState'],
        'activeState': json['activeState'],
        'suppressedState': json['suppressedState'] == null ? undefined : json['suppressedState'],
        'outOfServiceState': json['outOfServiceState'] == null ? undefined : json['outOfServiceState'],
        'shelvingState': json['shelvingState'] == null ? undefined : json['shelvingState'],
        'suppressedOrShelved': json['suppressedOrShelved'],
    };
}

export function UAAlarmConditionToJSON(json: any): UAAlarmCondition {
    return UAAlarmConditionToJSONTyped(json, false);
}

export function UAAlarmConditionToJSONTyped(value?: Omit<UAAlarmCondition, 'time'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'browseName': value['browseName'],
        'displayName': value['displayName'],
        'eventId': value['eventId'],
        'eventType': value['eventType'],
        'sourceNode': value['sourceNode'],
        'sourceName': value['sourceName'],
        'receiveTime': value['receiveTime'].toISOString(),
        'message': value['message'],
        'severity': value['severity'],
        'conditionName': value['conditionName'],
        'retain': value['retain'],
        'enabledState': value['enabledState'],
        'quality': value['quality'],
        'lastSeverity': value['lastSeverity'],
        'comment': value['comment'],
        'clientUserId': value['clientUserId'],
        'ackedState': value['ackedState'],
        'confirmedState': value['confirmedState'],
        'activeState': value['activeState'],
        'suppressedState': value['suppressedState'],
        'outOfServiceState': value['outOfServiceState'],
        'shelvingState': value['shelvingState'],
        'suppressedOrShelved': value['suppressedOrShelved'],
    };
}

